module.exports = __webpack_public_path__ + "img/carousel-premium-mob.f22cb1b7.png";